import {
    ableProps,
    ablePropsInit,
    requiredProps,
    requiredPropsInit,
    events as baseEvents,
} from '../component-base/props';
import { getFormConfig } from '../../config';
import { OCR_TYPE } from '../../const';
import { withDynamicCdn } from '../../utils/dynamic-cdn';
export const props = () => [
    ...ableProps,
    ...requiredProps,
    {
        key: 'isOcr',
        label: '是否图像识别',
        type: 'boolean',
    },
    {
        key: 'ocrType',
        label: '图像识别类型',
        type: 'enum',
        collection: [
            {
                label: '身份证',
                value: OCR_TYPE.ID_CARD,
            },
            {
                label: '银行卡',
                value: OCR_TYPE.BANK_CARD,
            },
            {
                label: '营业执照',
                value: OCR_TYPE.BUSINESS_LICENSE,
            },
        ],
        props: {
            clearable: true,
        },
    },
    {
        key: 'ocrFail',
        label: '识别失败文案',
        type: 'string',
        props: {
            maxlength: 45,
            showWordLimit: true,
            clearable: true,
        },
    },
    {
        key: 'ocrSuccess',
        label: '识别成功文案',
        type: 'string',
        props: {
            maxlength: 45,
            showWordLimit: true,
            clearable: true,
        },
    },
    {
        key: 'hideTitle',
        label: '是否隐藏标题文字',
        type: 'boolean',
    },
    {
        key: 'errUpload',
        label: '上传错误提示文案',
        type: 'string',
    },
    {
        key: 'errNetwork',
        label: '网络错误默认提示',
        type: 'string',
    },
    {
        key: 'tipRetry',
        label: '重试按钮文案',
        type: 'string',
    },
    {
        key: 'autoUpload',
        label: '选中文件后立即上传',
        type: 'boolean',
    },
    {
        key: 'action',
        label: '上传地址',
        type: 'string',
    },
    {
        key: 'accept',
        label: '格式限制',
        type: 'string',
        props: {
            placeholder: '如 image/* ,留空代表不限制',
        },
    },
    {
        // 约定0为不处理
        key: 'maxSize',
        label: '大小限制(kb)',
        type: 'number',
        props: {
            controls: false,
        },
    },
    {
        key: 'errSizeExceed',
        label: '大小超限提示',
        type: 'string',
    },
    {
        key: 'fileName',
        label: '上传时字段名',
        type: 'string',
        props: {
            placeholder: '上传文件时文件的name属性',
        },
    },
    {
        key: 'pickKey',
        label: '保留哪个返回值',
        type: 'string',
        props: {
            placeholder: '留空代表保留所有返回值',
        },
    },
    {
        key: 'previewSrc',
        label: '预览地址',
        type: 'string',
        props: {
            placeholder: '如 /a/b/c?id={file} 替换{file}为文件id',
        },
    },
    {
        key: 'subTitle',
        label: '标题描述',
        type: 'string',
        props: {
            placeholder: '需清晰，完整，无遮挡',
        },
    },
    {
        key: 'frontHint',
        label: '身份证人像面描述',
        type: 'string',
        props: {
            placeholder: '上传身份证人像面',
        },
    },
    {
        key: 'frontSrc',
        label: '人像面示例图',
        type: 'string',
        props: {
            placeholder: withDynamicCdn('udata/pkg/KS-COLLECT/static/ks-collect/img/id-preview-front.png'),
        },
    },
    {
        key: 'backHint',
        label: '身份证国徽面描述',
        type: 'string',
        props: {
            placeholder: '上传身份证国徽面',
        },
    },
    {
        key: 'backSrc',
        label: '国徽面示例图',
        type: 'string',
        props: {
            placeholder: withDynamicCdn('udata/pkg/KS-COLLECT/static/ks-collect/img/id-preview-back.png'),
        },
    },
];

export const init = () => {
    const formConfig = getFormConfig();
    return {
        ...ablePropsInit,
        ...requiredPropsInit,
        isOcr: false,
        ocrFail: '识别失败！请按照提示填写以下内容',
        ocrSuccess: '识别成功！请确保识别内容是否与图片信息一致',
        hideTitle: false,
        hint: '',
        errUpload: '上传失败',
        errNetwork: '网络错误',
        tipRetry: '点击重试',
        autoUpload: true,
        action: formConfig.uploadActionSrc,
        accept: 'image/jpeg, image/png',
        maxSize: 5120,
        errSizeExceed: '',
        fileName: 'file',
        pickKey: 'key',
        previewSrc: formConfig.uploadPreviewSrc,

        subTitle: '需清晰，完整，无遮挡',
        frontHint: '上传身份证人像面',
        frontSrc: withDynamicCdn('udata/pkg/KS-COLLECT/static/ks-collect/img/id-preview-front.png'),

        backHint: '上传身份证国徽面',
        backSrc: withDynamicCdn('udata/pkg/KS-COLLECT/static/ks-collect/img/id-preview-back.png'),
    };
};

export const name = '身份证上传（新）';

export const component = 'mobile-general-form-id-upload';

export const events = [
    'upload-success',
    'upload-clear',
    'change',
    ...baseEvents,
];

